<template>
  <div style="border: 0px solid black; width:100%;display:block;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;display: contents;width:100%;">
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">
              {{ $t("templateNotification.category.list") }}
            </h3>
          </div>
          <div class="box-body">
            <b-table striped hover :fields="fields" :items="items">
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template #cell(actions)="row">
                <div class="btn-group">
                  <button
                    class="btn btn-primary"
                    style="margin-left: 6px;"
                    @click="onViewTemplate(row.item)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>
                  </button>
                </div>
              </template>
            </b-table>
          </div>
          <div class="box-footer clearfix">
            <!-- <paginator :item="paginatorItem" @onpaginate="onPagination" /> -->
            <paginator
              :totalItem="paginateData.totalItem"
              :currentPage="paginateData.currentPage"
              :pageSize="paginateData.pageSize"
              :totalPage="paginateData.totalPage"
              @onpaginate="onPagination"
            />
          </div>
        </div>
      </row>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Paginator from "@/components/CustomPaginator.vue";
import utils from '@/lib/utils'

export default {
  components: {
    paginator: Paginator
  },
  data: () => ({
    fields: [
      { sortable: false, label: "common.nonumber", key: "nonumber" },
      {
        sortable: false,
        label: "templateNotification.category.table.headerName",
        key: "name"
      },
      {
        sortable: false,
        label: "templateNotification.category.table.headerNumberOfTemplate",
        key: "numberOfTemplate"
      },
      { sortable: false, label: "common.action", key: "actions" }
    ],
    items: [],
    paginatorItem: {
      commit_function: "GET_CATEGORY_NOTIFICATION"
    },
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    }
  }),
  watch: {
    GET_CATEGORY_NOTIFICATION_DATA: function() {
      let data = this.GET_CATEGORY_NOTIFICATION_DATA;
      let results = data.results;
      this.items = [];
      results.forEach((value, index) => {
        let item = {
          id: value.category,
          nonumber: index + 1,
          name: this.getTemplateCatagoryName(value.category),
          numberOfTemplate: value.numberOfTemplate
        };
        this.items.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_CATEGORY_NOTIFICATION_DATA"
    ])
  },
  methods: {
    getCategoryList: function(page) {
      let filter = {
        params: {
          page: page
        }
      };
      this.GET_CATEGORY_NOTIFICATION(filter);
    },
    getTemplateCatagoryName(category) {
      return this.$t(utils.getTemplateCatagoryName(category))
    },
    onViewTemplate: function(data) {
      this.$router.push({
        name: "TemplateNotification",
        params: {
          categoryId: data.id
        }
      });
    },
    onPagination: function(data) {
      this.paginateData.currentPage = data
      this.getCategoryList(data);
    },
    onPageChange: function() {},
    ...mapActions([
      "GET_CATEGORY_NOTIFICATION",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE"
    ])
  },
  created() {
    this.getCategoryList(1);
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Notification/NotificationCategory.vue